import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Button, FormControl, FormErrorMessage, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { MODAL_PASSWORD } from 'src/constants';
import TitleHeader from './common/TitleHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var EnterPasswordModal = function EnterPasswordModal(_ref) {
  var onClose = _ref.onClose,
      onSuccess = _ref.onSuccess;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useForm = useForm(),
      control = _useForm.control,
      handleSubmit = _useForm.handleSubmit,
      register = _useForm.register;

  var onSubmit = useCallback(function () {
    onClose();
    onSuccess();
  }, [onClose, onSuccess]);
  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: true,
    onClose: onClose,
    e2eid: "components_EnterPasswordModal_Modal",
    children: [/*#__PURE__*/_jsx(ModalOverlay, {
      e2eid: "components_EnterPasswordModal_ModalOverlay"
    }), /*#__PURE__*/_jsxs(ModalContent, {
      e2eid: "components_EnterPasswordModal_ModalContent",
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        e2eid: "components_EnterPasswordModal_ModalHeader",
        children: /*#__PURE__*/_jsx(TitleHeader, {
          e2eid: "components_EnterPasswordModal_TitleHeader",
          children: "".concat(t('common:form.pleaseEnterPassword', '請輸入密碼'), "\uFF1A")
        })
      }), /*#__PURE__*/_jsxs("form", {
        onSubmit: handleSubmit(onSubmit),
        e2eid: "components_EnterPasswordModal_form",
        children: [/*#__PURE__*/_jsx(ModalBody, {
          e2eid: "components_EnterPasswordModal_ModalBody",
          children: /*#__PURE__*/_jsx(Controller, {
            name: "password",
            control: control,
            render: function render(_ref2) {
              var field = _ref2.field,
                  error = _ref2.fieldState.error;
              return /*#__PURE__*/_jsxs(FormControl, {
                isInvalid: !!error,
                e2eid: "components_EnterPasswordModal_FormControl",
                children: [/*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread(_objectSpread({}, field), register('password', {
                  validate: function validate(value) {
                    return value === MODAL_PASSWORD || t('common:wrongPassword', '密碼錯誤');
                  }
                })), {}, {
                  type: "password",
                  autoComplete: "new-password",
                  e2eid: "components_EnterPasswordModal_Input"
                })), /*#__PURE__*/_jsx(Box, {
                  minH: 6,
                  mt: 2,
                  e2eid: "components_EnterPasswordModal_Box",
                  children: error && /*#__PURE__*/_jsx(FormErrorMessage, {
                    e2eid: "components_EnterPasswordModal_FormErrorMessage",
                    children: error.message
                  })
                })]
              });
            },
            e2eid: "components_EnterPasswordModal_Controller"
          })
        }), /*#__PURE__*/_jsxs(ModalFooter, {
          w: "full",
          e2eid: "components_EnterPasswordModal_ModalFooter",
          children: [/*#__PURE__*/_jsx(Button, {
            mr: 3,
            variant: "outline",
            onClick: onClose,
            e2eid: "components_EnterPasswordModal_Button",
            children: t('common:button.cancel', '取消')
          }), /*#__PURE__*/_jsx(Button, {
            type: "submit",
            e2eid: "components_EnterPasswordModal_Button_14",
            children: t('common:button.confirm', '確認')
          })]
        })]
      })]
    })]
  });
};

export default EnterPasswordModal;